import { render, staticRenderFns } from "./ticket-detail.vue?vue&type=template&id=2b3a8df8&scoped=true&"
import script from "./ticket-detail.vue?vue&type=script&lang=js&"
export * from "./ticket-detail.vue?vue&type=script&lang=js&"
import style0 from "./ticket-detail.vue?vue&type=style&index=0&id=2b3a8df8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a8df8",
  null
  
)

export default component.exports